<template>
  <b-row>
    <b-col v-if="hasGuests.adults">
      <BookingGuests
        :guests="guests.adults"
        @set-guests-in-properties="setDataInGuests"        
      />
    </b-col>
    <b-col md="5" v-if="hasGuests.childs">
      <BookingGuests
        :guests="guests.childs"
        @set-guests-in-properties="setDataInGuests"
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "vuex";
import { namesPrefix } from '@/data/data';
import BookingGuests from "@/modules/shop/components/orderSummary/BookingGuests"

export default {
  props: {
    booking: {
      type: Object,
      required: false,
    },
  },
  components: {
    BookingGuests,
  },
  data() {
    return {
      max: 255,
      namesPrefix,
      daGuest: '',      
      selectedGuest: [],      
      childages: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17]
    };
  },
  computed: {
    ...mapState('mySales',['searchForm']),
    ...mapState('start',['countries']),
    hasGuests(){
      const adults = this.booking?.guests?.adults && this.booking?.guests?.adults?.length > 0
      const childs = this.booking?.guests?.childs && this.booking?.guests?.childs?.length > 0
      return {adults, childs}
    },
    guests() {
      const { adults = [], childs = [] } = this.booking?.guests || {}

      const toId = v => (v == null ? null : String(v)) 

      const guests = {
        adults: adults.map(g => ({
          ...g,
          country: toId(g.country),
          countryCode: null, 
        })),
        childs: childs.map(g => ({
          ...g,
          country: toId(g.country),
          countryCode: null, 
        })),
      }
      this.booking.guests = guests
      return guests
    },
  },
  methods: {
    setDataInGuests() {
      return true
    },
        
  },
};
</script>

<style scoped>
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #177bd2;
  background-color: #267dc7 !important;
}

label.custom-control-label {
  font-weight: 600;
}
</style>